import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import MarketTicker from './components/MarketTicker';
import FeaturesSection from './components/FeaturesSection';
import TestimonialCarousel from './components/TestimonialCarousel';
import EducationalPreview from './components/EducationalPreview';
import TrustBadges from './components/TrustBadges';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <Header />
      
      <main className="pt-16">
        <HeroSection />
        <MarketTicker />
        <FeaturesSection />
        <TestimonialCarousel />
        <EducationalPreview />
        <TrustBadges />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;